import {createStyles, makeStyles, Theme} from "@material-ui/core";
import Chart from "react-google-charts";
import {BOX_SHADOWS, FONTS, SECONDARY_COLOR} from "../../constants";
import {formatNumber} from "../../helpers/FormatNumber";
import {stateType} from "../../state";

import {BoxHeader} from "../Common/BoxHeader";
import {BAR_COLORS} from "../VariableCorrelations/DualChart";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			width: "100%",
			backgroundColor: "white",
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			position: "relative",
			height: "550px",
		},
		pieChartTitle: {
			fontFamily: FONTS,
			color: "rgba(0,0,0,0.7)",
			textAlign: "center",
			fontWeight: "bold",
			fontSize: "16px",
			marginTop: "10px",
			marginBottom: "0px",
		},
		pieChartFooter: {
			fontFamily: FONTS,
			color: "rgba(0,0,0,0.7)",
			textAlign: "center",
			width: "100%",
			height: "20px",
			fontSize: "16px",
			marginBottom: "10px",
			marginTop: "10px",
		},
	})
);

export function PieChart({state}: stateType) {
	const classes = useStyles();
	if (state.saveState.batchPrediction.batchData === undefined) {
		return <div></div>;
	}

	let bData = state.saveState.batchPrediction.batchData.data;
	let data: any[][] = [[state.saveState.modelTraining.valueToPredict, ""]];
	let counts: Map<string, number> = new Map();
	let predValues: string[] = [];
	for (let d of bData) {
		let predVal = d[1];
		if (counts.has(predVal)) {
			counts.set(predVal, counts.get(predVal) + 1);
		} else {
			predValues.push(predVal);
			counts.set(predVal, 1);
		}
	}
	predValues = predValues.sort();
	for (let val of predValues) {
		data.push([val, counts.get(val)]);
	}

	let chartTitle = `Predicted Values for '${state.saveState.modelTraining.valueToPredict}'`;

	let row_count = bData.length;

	return (
		<div
			style={{
				height: "100%",
				width: "100%",
				flex: 1,
				overflow: "auto",
			}}
		>
			<div className={classes.pieChartTitle}>{chartTitle}</div>
			<div
				style={{
					position: "relative",
					width: "100%",
					left: "2%",
				}}
			>
				<Chart
					chartType={"PieChart"}
					loader={<div>Loading Chart</div>}
					data={data}
					style={{
						height: "400px",
						width: "98%",
						overflow: "hidden",
						position: "relative",
					}}
					options={{
						colors: BAR_COLORS,
						series: [{color: SECONDARY_COLOR, dataOpacity: 0.65}],
						legend: {
							position: "labeled",
							labeledValueText: "value",
							textStyle: {bold: true, fontName: FONTS},
						},
						is3D: false,
						chartArea: {
							width: "90%",
							height: "90%",
						},
						pieSliceTextStyle: {
							color: "white",
							fontFamily: FONTS,
							fontWeight: "bold",
						},
						pieSliceText: "none",

						pieHole: 0.4,
					}}
				/>
			</div>
			<div className={classes.pieChartFooter}>
				{formatNumber(row_count)} Values
			</div>
		</div>
	);
}

export function PredictedChartBox({state}: stateType) {
	let classes = useStyles();
	return (
		<div className={classes.container}>
			<div style={{width: "100%", marginBottom: "-10px"}}>
				<BoxHeader
					title={`Predicted Values Proportion`}
					toolTip={`Shows which variables have the largest relative influence on predicting ${state.saveState.modelTraining.valueToPredict}.`}
					line={true}
				></BoxHeader>
			</div>

			<PieChart state={state}></PieChart>
		</div>
	);
}
